export default {
  resourceManagers: {
    searchPlaceholder: '検索',
    all: 'すべて',
    back: '戻る',
    searchResults: '検索結果',
    audioUploader: {
      localUpload: 'ローカルにアップロード',
      tips: 'すべてのアセットを閲覧',
    },
    dialog: {
      tips: '現在のフォーマット要件に合致するアセットのみ表示',
    },
    apply: 'フィルター条件を適用',
    clearAll: 'すべてクリア',
    noDataTip: 'データがありません',
  },
}
